import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { ROUTE_ROLES, CRM_SCREEN_ROLES } from "@/lib/roles";

const DEFAULTS = { os: ROUTE_ROLES, crm: CRM_SCREEN_ROLES, loaded: false, meta: null };
const PermCtx = createContext({ ...DEFAULTS, reload: () => {} });
export const usePerms = () => useContext(PermCtx);

// Director-editable role matrix (Settings → Role Permissions). Falls back to code defaults.
export function PermissionsProvider({ children }) {
  const { user } = useAuth();
  const [state, setState] = useState(DEFAULTS);
  const reload = useCallback(async () => {
    try {
      const { data } = await api.get("/permissions");
      setState({ os: data.os, crm: data.crm, loaded: true, meta: data });
    } catch {
      setState({ ...DEFAULTS, loaded: true });
    }
  }, []);
  useEffect(() => {
    if (user) reload();
    else setState(DEFAULTS);
  }, [user, reload]);
  return <PermCtx.Provider value={{ ...state, reload }}>{children}</PermCtx.Provider>;
}
